import { VideoData } from "functions/src/MMI/MMIInterfaces";
// export const  = "";
// Actions
// export const action = "action";

// Mutations
// export const MUTATION_EXAMPLE = "MUTATION_EXAMPLE";
export const SET_USER_STRUCTURE = "SET_USER_STRUCTURE";
export const SET_CHAPTER_PLAYLIST = "SET_CHAPTER_PLAYLIST";
export const SET_CHAPTER_WATCHED_VIDEOS = "SET_CHAPTER_WATCHED_VIDEOS";
export const SET_CHAPTER_WATCHED_VIDEOS_LISTENER =
  "SET_CHAPTER_WATCHED_VIDEOS_LISTENER";
export const CLEAR_CHAPTER_WATCHED_VIDEOS_LISTENER =
  "CLEAR_CHAPTER_WATCHED_VIDEOS_LISTENER";

export type Chapters = "colombia";

/**
 * DOS ÁRBOLES DEL ACELERADOR (CMMI): cuál es el vivo y por qué hay dos.
 *
 * El reinicio de red reconstruyó la estructura del Acelerador en una colección
 * NUEVA, `mmiTree/{capítulo}/structure`, y dejó la vieja —`mmi/{capítulo}/
 * structure`— congelada en su sitio, tal cual estaba, sin borrarla. Desde el
 * corte, TODA alta pasa por `placeMmiMember` (`functions/src/MMI/
 * PlaceMmiMember.ts`) y aterriza sólo en la nueva; la vieja ya no la escribe
 * nadie. El backend construye la ruta en un único helper,
 * `mmiStructureCollection()` de `functions/src/Subscriptions/Activations/
 * PathHelpers.ts`, que apunta a `mmiTree`.
 *
 * POR QUÉ IMPORTA, Y NO ES UN DETALLE: los renombrados del reinicio
 * (`gtr.academy` → `gtr.master`, `laurapelayo` → `patybrambila`) se aplicaron
 * SÓLO al árbol nuevo. En el viejo esas personas siguen con su nombre de antes,
 * o sea que buscarlas por su nombre de hoy en la colección vieja no encuentra
 * nada. Eso es exactamente lo que le decía «¿Cómo que no cuentas con este
 * producto?» a socios con `mmi-colombia` vigente: el front preguntaba por el
 * documento en el árbol congelado, no existía, y se pintaba la cara de compra.
 *
 * El nombre del capítulo es el MISMO en las dos colecciones (`colombia`). No
 * confundirlo con `mmi-colombia`, que es el id del PRODUCTO en el catálogo de
 * suscripciones y es otra cosa.
 *
 * La ruta vive aquí y sólo aquí. Que estuviera escrita a mano en cada sitio que
 * la usa es justo lo que permitió que el front se quedara atrás cuando el
 * backend se mudó.
 */
export const MMI_TREE_COLLECTION = "mmiTree";
export const MMI_STRUCTURE_SUBCOLLECTION = "structure";

/**
 * Los segmentos de la colección de estructura del capítulo, listos para
 * derramar en `doc()` o `collection()` del SDK de Firestore:
 *
 *   doc(fb.firestore, ...mmiStructurePath(chapter), username)
 *
 * El `toLowerCase()` replica lo que hace el helper del backend, para que las
 * dos partes no puedan discrepar en el id del documento del capítulo.
 */
export function mmiStructurePath(chapter: Chapters): [string, string, string] {
  return [
    MMI_TREE_COLLECTION,
    chapter.toLowerCase(),
    MMI_STRUCTURE_SUBCOLLECTION,
  ];
}

export interface MMIState {
  colombia: ChapterData;
}

export interface ChapterData {
  users: Map<string, MMIUser>;
  videos: Array<VideoData>;
  watchedVideos: Array<string>;
}

export interface MMIUser {
  _usernamePK: string;
  username: string;
  nickname: string;
  currentRankId: string;
  rankIconClass: string;
  profilePicture: string;
  isPassUp: boolean;
  parent: string;
  initialDate: Date;
  users: Array<MMIUser>;
}
